import { mutatorAction } from "satcheljs";
import { shiftEditorViewState } from "..";

export default mutatorAction("setAccessibilityAlert", function setAccessibilityAlert(alertMessage: string) {
    shiftEditorViewState().accessibilityAlertMessage = alertMessage;
});